module.exports = __webpack_public_path__ + "img/slider_thumb.2812c7d3.svg";